import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Alert, Grid, Snackbar } from '@mui/material';
import * as EventActions from '../../../../../core/events/action';
import { TranslucentContainer } from '../../../../../components';
import RatingModal from '../RatingModal';
import CardByRole from './components/CardByRole';

function PastEvents() {
  const dispatch = useDispatch();
  const { pastEvents } = useSelector((store) => store.events);
  const { user } = useSelector((store) => store.users);

  const [reviewee, setReviewee] = useState(undefined);
  const [isRatingModalOpen, setIsRatingModalOpen] = useState(false);
  const [isFeedbackVisible, setIsFeedbackVisible] = useState(false);

  useEffect(() => {
    if (!user?.id || !user?.role?.name) return;
    dispatch(EventActions.getPastEvents(user.id, user.role.name));
  }, [dispatch, user]);

  const handleRateClicked = (revieweeData) => {
    setReviewee(revieweeData);
    setIsRatingModalOpen(true);
  };

  const handleClose = () => {
    setIsRatingModalOpen(false);
    setReviewee(undefined);
  };

  return (
    <Grid container marginTop={5} justifyContent="center">
      <TranslucentContainer>
        <Grid container justifyContent="start" marginTop={8}>
          {Boolean(user?.role?.name) &&
            pastEvents?.map((e) => (
              <CardByRole
                key={e.id}
                role={user.role.name}
                event={e}
                handleRateClicked={handleRateClicked}
              />
            ))}
        </Grid>
      </TranslucentContainer>
      {reviewee && (
        <RatingModal
          reviewee={reviewee}
          reviewerId={user.id}
          isOpen={isRatingModalOpen}
          onClose={handleClose}
          onSubmit={() => setIsFeedbackVisible(true)}
        />
      )}
      <Snackbar
        open={isFeedbackVisible}
        autoHideDuration={6000}
        onClose={() => setIsFeedbackVisible(false)}>
        <Alert
          onClose={() => setIsFeedbackVisible(false)}
          severity="success"
          sx={{ width: '100%' }}>
          Feedback sent successfully!
        </Alert>
      </Snackbar>
    </Grid>
  );
}

export default PastEvents;
